const BASE_PATH = '/book'
const ASHTAPADI_PATH = `${BASE_PATH}/:id/ashtapadi`
const PAURI_PATH = `${ASHTAPADI_PATH}/:ashtapadiId/pauri`

const BASE_META = {
  allowAnonymous: false,
  parent: 'BookList'
}

export default [
  /* ------------------------------------------------------- ashtapadi ------------------------------------------------------- */
  {
    path: ASHTAPADI_PATH,
    name: 'ashtapadi',
    component: () => import('@/views/book/type-2/ashtapadi/index.vue'),
    meta: {
      ...BASE_META,
      pageTitle: 'Ashtapadi',
      permissions: ['book_edit']
    }
  },
  {
    path: `${ASHTAPADI_PATH}/add`,
    name: 'add-ashtapadi',
    component: () => import('@/views/book/type-2/ashtapadi/action.vue'),
    meta: {
      ...BASE_META,
      pageTitle: 'Add Ashtapadi',
      permissions: ['book_edit']
    }
  },
  {
    path: `${ASHTAPADI_PATH}/edit/:ashtapadiId`,
    name: 'edit-ashtapadi',
    component: () => import('@/views/book/type-2/ashtapadi/action.vue'),
    meta: {
      ...BASE_META,
      pageTitle: 'Edit Ashtapadi',
      permissions: ['book_edit']
    }
  },

  /* ------------------------------------------------------- pauri & slok ------------------------------------------------------- */
  {
    path: `${PAURI_PATH}`,
    name: 'ashtapadiPauri',
    component: () => import('@/views/book/type-2/ashtapadi/pauri/index.vue'),
    meta: {
      ...BASE_META,
      pageTitle: 'Pauri & Slok',
      permissions: ['book_edit']
    }
  },
  {
    path: `${PAURI_PATH}/add/:type`,
    name: 'add-ashtapadi-pauri',
    component: () => import('@/views/book/type-2/ashtapadi/pauri/action.vue'),
    meta: {
      ...BASE_META,
      pageTitle: 'Add Pauri',
      permissions: ['book_edit']
    }
  },
  {
    path: `${PAURI_PATH}/edit/:pauriId/:type`,
    name: 'edit-ashtapadi-pauri',
    component: () => import('@/views/book/type-2/ashtapadi/pauri/action.vue'),
    meta: {
      ...BASE_META,
      pageTitle: 'Edit Pauri',
      permissions: ['book_edit']
    }
  }
]
